const baseUrl = process.env.REACT_APP_API_BASE_URL || 'https://adm.disaica.us/';
const consumer_key_gf = process.env.REACT_APP_GF_CONSUMER_KEY || '';
const secret_key_gf = process.env.REACT_APP_GF_SECRET_KEY || '';

const navItems = [
    {
      title: "Home",
      link: "/",
      subLinks: [],
    },
    {
      title: "About",
      link: "/about",
      subLinks: [],
    },
    {
      title: "Services",
      link: "/services",
      subLinks: [],
    },
    {
      title: "Portfolio",
      link: "/portfolio",
      subLinks: []
    },
    {
      title: "Contact",
      link: "/contact",
      subLinks: [],
    },
  ];

export {
    baseUrl,
    navItems,
    consumer_key_gf,
    secret_key_gf
}